<template>

  <div>
    <div class="children-container">
      <div class="children-module-name">账户与安全</div>
      <div style="display: flex;background-color: #FFFFFF;padding: 10px;width: 100%;flex-direction: column">
        <div style="display: flex;width: 100%">
          <div style="flex: 1;border-right: 1px solid #f5f5f5;">
            <div class="children-module-info" style="font-size: 14px">
              <div class="info-list"><div class="label">用户ID</div><div>{{ userInfo.id }}</div></div>
              <div class="info-list"><div class="label">*手机号</div><div>{{ userInfo.mobile }}</div><div class="op" @click="openMobile">（修改）</div></div>
              <div class="info-list"><div class="label">*邮箱</div><div>{{ userInfo.mail }}</div><div class="op" @click="openEmail">（修改）</div></div>
              <div class="info-list"><div class="label">登陆密码</div>
                <div class="flex" v-if="userInfo && userInfo.login_pwd"><div>已设置</div><div class="op" @click="openPwd">（修改）</div></div>
                <div class="flex" v-else><div>未设置</div><div class="op" @click="openPwd">（去设置）</div></div>
              </div>
              <div v-if="userInfo && userInfo.is_sale == 'FALSE'" class="info-list"><div class="label">账号认证</div>
                <div v-if="isSecurity == true" style="color: #0d959c;font-weight: bold">已认证</div>{{userInfo.isSecurity}}
                <div v-if="isSecurity == false"  style="font-weight: bold">未认证</div><div style="padding-left: 40px">(点击下方去认证) </div>
              </div>
              <div style="display: flex">
                <div v-if="userInfo && userInfo.is_sale == 'FALSE'" class="info-list go" @click="goPi" style="margin-right: 20px"><img style="width: 200px" src="https://jc-yk-static.oss-cn-shanghai.aliyuncs.com/p-data-1.png"
                                                                                                            alt=""></div>
                <div v-if="userInfo && userInfo.is_sale == 'FALSE'" class="info-list go" @click="goUnit"><img style="width: 200px" src="https://jc-yk-static.oss-cn-shanghai.aliyuncs.com/p-data-2.png"
                                                                                                              alt=""></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="mobileVisible" title="您正在进行绑定手机号的操作" @ok="actionMobile" :width="650" :destroyOnClose="true" :disabled="$store.state.requestLoading">
      <a-form-model ref="mobileForm" :rules="mobileFormRules" :model="mobileForm" layout="vertical"
                    :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="手机号" prop="mobile">
          <a-input placeholder="请输入手机号" v-model="mobileForm.mobile"></a-input>
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="code">
          <a-input style="width: 120px;margin-right: 20px;" placeholder="请输入验证码" v-model="mobileForm.code"></a-input>
          <a-button style="width: 128px;" v-if="mobileCodeFlag == true">{{mobileCodeStr}}</a-button>
          <a-button style="width: 128px;background-color: #dddddd;color: #333;font-weight: normal;border:1px solid #dddddd;box-shadow:none" v-else type="primary" @click="getMobileCode"
                    :disabled="$store.state.requestLoading">获取验证码</a-button>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 5 }">
<!--          <a-button type="primary" block @click="submitMobileData">{{mobileViewData.mobile ? '更换手机号' : '确定'}}</a-button>-->
        </a-form-model-item>
      </a-form-model>
    </a-modal>

      <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="emailVisible" title="您正在进行绑定邮箱的操作" @ok="actionEmail"
               :width="650" :destroyOnClose="true" :disabled="$store.state.requestLoading">
        <a-form-model dialogClass="custom-dialog" :maskClosable="false" ref="mailForm" :rules="mailFormRules" :model="mailForm" layout="vertical"
                      :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item label="邮箱" prop="mail">
            <a-input placeholder="请输入邮箱" v-model="mailForm.mail"></a-input>
          </a-form-model-item>
          <a-form-model-item label="验证码" prop="code">
            <a-input style="width: 120px;margin-right: 20px;" placeholder="请输入验证码" v-model="mailForm.code"></a-input>
            <a-button style="width: 128px;" v-if="mailCodeFlag == true">{{mailCodeStr}}</a-button>
            <a-button style="width: 128px;background-color: #dddddd;color: #333;font-weight: normal;border:1px solid #dddddd;box-shadow:none" v-else type="primary" @click="getMailCode" :disabled="$store.state.requestLoading">获取验证码</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    <a-modal dialogClass="custom-dialog" :maskClosable="false" v-model="passVisible" title="修改登录密码" @ok="actionPass" :width="650" :destroyOnClose="true" :disabled="$store.state.requestLoading">
      <a-form-model ref="userFormLogin" :rules="userFormLoginRules" :model="userFormLogin" layout="vertical"
                    :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="登录密码" prop="login_pwd">
          <a-input type="password" placeholder="请输入登录密码" v-model="userFormLogin.login_pwd"></a-input>
        </a-form-model-item>
        <a-form-model-item label="再次输入登录密码" prop="login_pwd1">
          <a-input type="password" placeholder="请再次输入登录密码" v-model="userFormLogin.login_pwd1"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 4 }">
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<style>
.info-list {
  display: flex;
  line-height: 60px;
}
.info-list .label {
  width: 100px;
}
.info-list .op {
  color: #007F76;
  cursor: pointer;
}
.flex {
  display: flex;
}
.go {
  color: #007F76;
  cursor: pointer;
}
</style>
<script>
  import * as Api from './api';
  import * as commonApi from '@/commonApi';

  export default {
    data() {
      let validateMail = (rule, value, callback) => {
        if (!commonApi.EmailReg.test(value)) {
          callback(new Error("请输入正确的邮箱"));
        }
        callback();
      };

      let validateMobile = (rule, value, callback) => {
        if (!commonApi.MobileReg.test(value)) {
          callback(new Error("请输入正确的手机号"));
        }
        callback();
      };
      let validatePwd = (rule, value, callback) => {
        if (this.userFormLogin.login_pwd != value) {
          callback(new Error("两次密码输入不一致"));
        }
        callback();
      };
      return {
        isSecurity: '',
        userInfo: {},
        mobileVisible: false,
        emailVisible: false,
        passVisible: false,
        // 手机号
        mobileForm: {
          mobile: '',
          code: ''
        },
        mobileFormRules: {
          mobile: [{ required: true, message: '请输入手机号', trigger: 'change' }, { validator: validateMobile, trigger: 'change' }],
          code: [{ required: true, message: '请输入验证码', trigger: 'change' }]
        },
        mobileTimeId: null,
        mobileCodeStr: '',
        mobileTime: 60,
        mobileCodeFlag: false,
        // 邮箱
        mailForm: {
          mail: '',
          code: ''
        },
        mailFormRules: {
          mail: [{ required: true, message: '请输入邮箱', trigger: 'change' },{ validator: validateMail, trigger: 'change' }],
          code: [{ required: true, message: '请输入验证码', trigger: 'change' }]
        },
        mailTimeId: null,
        mailCodeStr: '',
        mailTime: 60,
        mailCodeFlag: false,
        mailViewData: {
          mail: ''
        },
        userFormLogin: {
          login_pwd: '',
          login_pwd1: '',
        },
        userFormLoginRules: {
          login_pwd: [{ required: true, message: '请输入登录密码', trigger: 'change' }],
          login_pwd1: [{ required: true, message: '请再次输入登录密码', trigger: 'change' },{ validator: validatePwd, trigger: 'change' }],
        },
      };
    },
    mounted() {
      this.getInfo();
    },
    methods: {
      // 获取账户列表
      async getAccountList() {
        let res = await Api.GetAccountList({});
        if (res && res["code"] == "0") {
          if (res && res.list.length > 0) {
            this.isSecurity = true;
          } else {
            this.isSecurity = false;
          }
        }
      },

      openMobile() {
        this.mobileVisible = true;
      },
      // 获取验证码
      async getMobileCode() {
        if (!commonApi.MobileReg.test(this.mobileForm.mobile)) {
          this.$message.error('请输入正确的手机号');
          return;
        }
        let res = await Api.SendCodeToMobile({ mobile: this.mobileForm.mobile });
        if (res && res['code'] == '0') {
          this.mobileCodeTime()
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      },
      // 验证码倒计时
      mobileCodeTime() {
        this.mobileCodeFlag = true;
        this.mobileCodeStr = `${this.mobileTime}s后重新获取`
        this.mobileTimeId = setInterval(() => {
          if (this.mobileTime > 1) {
            this.mobileTime--;
            this.mobileCodeStr = `${this.mobileTime}s后重新获取`
          } else {
            this.mobileCodeFlag = false;
            clearInterval(this.mobileTime)
            this.mobileTime = 60
          }

        }, 1000);
      },
      actionMobile() {
        this.$refs.mobileForm.validate(async valid => {
          if (valid) {
            let res = await Api.ChangeMobile(this.mobileForm);
            if (res && res['code'] == '0') {
              this.$message.success(res.message);
              this.mobileForm.code = '';
              this.mobileForm.mobile = ''
              if (this.mobileTimeId) {
                clearInterval(this.mobileTimeId)
              }
              this.mobileVisible = false;
              this.getInfo();

            } else {
              this.$message.error(res.message);
            }
          }
        });
      },
      openEmail() {
        this.emailVisible = true;
      },
      // 获取验证码
      async getMailCode() {
        if (!commonApi.EmailReg.test(this.mailForm.mail)) {
          this.$message.error('请输入正确的邮箱');
          return;
        }
        let res = await Api.SendCodeToMail({ mail: this.mailForm.mail });
        if (res && res['code'] == '0') {
          this.mailCodeTime()
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      },
      // 验证码倒计时
      mailCodeTime() {
        this.mailCodeFlag = true;
        this.mailCodeStr = `${this.mailTime}s后重新获取`
        this.mailTimeId = setInterval(() => {
          if (this.mailTime > 1) {
            this.mailTime--;
            this.mailCodeStr = `${this.mailTime}s后重新获取`
          } else {
            this.mailCodeFlag = false;
            clearInterval(this.mailTimeId)
            this.mailTime = 60
          }

        }, 1000);
      },
      actionEmail() {
        this.$refs.mailForm.validate(async valid => {
          if (valid) {
            let res = await Api.ChangeMail(this.mailForm);
            if (res && res['code'] == '0') {
              this.$message.success(res.message);
              this.mailForm.code = '';
              this.mailForm.mail = ''
              if (this.mailTimeId) {
                clearInterval(this.mailTimeId)
              }
              this.emailVisible = false;
              this.getInfo();

            } else {
              this.$message.error(res.message);
            }
          }
        });
      },
      openPwd() {
        this.passVisible = true;
      },
      actionPass() {
        this.$refs.userFormLogin.validate(async valid => {
          if (valid) {
            let res = await Api.SetLoginPwd(this.userFormLogin);
            if (res && res['code'] == '0') {
              this.$message.success(res.message);
              this.userFormLogin.login_pwd = '';
              this.userFormLogin.login_pwd1 = '';
              this.passVisible = false;
              this.getInfo();
            } else {
              this.$message.error(res.message);
            }
          }
        });
      },
      goPi() {
        this.$router.push({ path: '/personal-user-authentication' });
      },
      goUnit() {
        this.$router.push({ path: '/enterprise-user-authentication' });
      },
      // 获取信息
      async getInfo() {
        let res = await Api.GetInfo({});
        if (res && res["code"] == "0") {
          this.userInfo = res.user;
          if (this.userInfo && this.userInfo.is_sale == 'FALSE') {
            this.getAccountList()
          }
        } else {
          this.$message.error(res.message);
        }
      }
    },
  };
</script>

<style lang="less">
  .tips-text {
    font-size: 14px;
    font-weight: 500;
    color: #007F76;
    line-height: 38px;
    padding-top: 2px;
  }

  .code {
    background-color: #007F76;
    font-size: 12px;
    color: #fff;
    font-weight: 500;
  }
  .children-module-content {
    background-color: #fff;
  }
</style>